<p-sidebar [visible]="true"
           [position]="'right'"
           [baseZIndex]="10000"
           [modal]="true"
           (onHide)="onSideBarHide()"
           [style]="{width:'806px'}">

    <ng-template pTemplate="header">ORDER ID: {{orderId}}</ng-template>
    <ng-template pTemplate="content">
        <p-tabMenu [model]="menuItems"
                   [activeItem]="activeItem"
                   (activeItemChange)="onActiveItemChange($event)"></p-tabMenu>

        <div style="height: 14px"></div>

        <mart-order-details-info-tab *ngIf="activeItem.id===martOrderDetailsTab.Info"
                                     [parent]="this"></mart-order-details-info-tab>

        <mart-order-details-products-tab *ngIf="activeItem.id===martOrderDetailsTab.Products"
                                         [parent]="this"></mart-order-details-products-tab>

        <mart-order-details-payment-tab *ngIf="activeItem.id===martOrderDetailsTab.Payment"
                                        [parent]="this"></mart-order-details-payment-tab>

        <mart-order-details-chat-tab *ngIf="activeItem.id===martOrderDetailsTab.Messages"
                                     [parent]="this"></mart-order-details-chat-tab>

        <mart-order-details-timeline-tab *ngIf="activeItem.id===martOrderDetailsTab.Timeline"
                                         [parent]="this"></mart-order-details-timeline-tab>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex-row" style="padding: 30px;">
            <div class="filler"></div>
            <div>
                <button pButton type="button" label="Print"></button>
            </div>
        </div>
    </ng-template>
</p-sidebar>

<spinner *ngIf="isSpinnerVisible" style="position: fixed; top: 40vh; left: 70vw; z-index: 10001;"></spinner>

<p-toast position="top-right"></p-toast>
